@if (cappedChips?.length) {
  @if (infoLabel) {
    <span class="[ label-small ]">{{ infoLabel }}</span>
  }
  <campus-chip-group>
    @for (chip of cappedChips; track chip) {
      <campus-suggestion-chip
        data-cy="tli-assignee-chip"
        [class.surface-variant]="chip.type === '--overflow'"
        [class.border-dashed]="chip.className === '--dashed'"
        [label]="chip.label"
        >
        @if (chip.icon) {
          <campus-icon chip-icon [svgIcon]="chip.icon"></campus-icon>
        }
      </campus-suggestion-chip>
    }
  </campus-chip-group>
} @else {
  @if (ctaLabel) {
    <button filled-button [leadingIcon]="ctaIcon">
      {{ ctaLabel }}
    </button>
  }
}

